export const isDevelopment = () : boolean => {
  return process.env.REACT_APP_ENV === 'development';
};

export const ACCESS_TOKEN = 'bionexo.auth.access_token';

export const CURRENT_PRODUCT = 'biobar.current_product';

export const CURRENT_IDENTIFIER = 'biobar.identifier';

export const CURRENT_COMPANY_ID = 'biobar.identifier.product.company_id';

export const PREFERRED_LANGUAGE = 'NEXT_LOCALE';

export const COOKIE_DOMAIN = '.bionexo.com';

export const IMPERSONATE = 'biobar_session_impersonate';

export const FAVORITE_PRODUCT_URL = process.env.REACT_APP_FAVORITE_PRODUCT_URL || '';

export function redirectFavoriteProduct() : void {
  window.location.href = FAVORITE_PRODUCT_URL;
}